import React from 'react'
import { Checkbox, Description, Field, Label } from '@headlessui/react'
import { CheckIcon } from '@heroicons/react/24/solid'
import { ErrorMessage } from '../ErrorMessage'

interface CheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label?: string
  description?: string
  disabled?: boolean
  error?: string
  name: string
  required?: boolean
}

export const CheckboxInput = ({
  checked = false,
  onChange,
  label,
  description,
  disabled,
  error,
  name,
  required,
}: CheckboxProps) => {
  const checkboxId = `checkbox-${name}`
  const errorId = error ? `${checkboxId}-error` : undefined

  return (
    <Field
      role="group"
      disabled={disabled}
      aria-disabled={disabled}
      aria-label={label}
      aria-describedby={errorId}
      className="space-y-2"
    >
      <div className="flex items-center space-x-2">
        <Checkbox
          checked={checked}
          aria-checked={checked}
          data-testid={name}
          name={name}
          onChange={onChange}
          aria-disabled={disabled}
          disabled={disabled}
          aria-required={required}
          aria-invalid={Boolean(error)}
          className="group flex items-center justify-center rounded-lg border border-night bg-white data-[checked]:bg-night cursor-pointer disabled:cursor-not-allowed disabled:bg-gray-200 disabled:border-gray-200 disabled:text-gray-500 disabled:opacity-50"
        >
          <CheckIcon className="w-6 h-6 opacity-0 group-data-[checked]:opacity-100 text-white" />
        </Checkbox>
        {label && (
          <Label className="font-medium cursor-pointer text-night text-sm/6">
            {label}
            {required && <span className="ml-1 text-red-500">*</span>}
          </Label>
        )}
      </div>

      {description && (
        <Description className="font-thin text-gray-500 text-sm/6">
          {description}
        </Description>
      )}
      <ErrorMessage
        error={error}
        data-testid={`${name}-error`}
      />
    </Field>
  )
}
